var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57445 9.99762L11.9989 5.37711L16.4255 10L19 7.31144L11.9989 0L5 7.30906L7.57445 9.99762ZM0 12L3 9L6 12L3 15L0 12ZM12.0006 18.6229L7.57724 14.0024L5 16.6874L5.00342 16.6909L12.0006 24L19 16.6874L16.4262 14L12.0006 18.6229ZM18 12L21 9L24 12L21 15L18 12ZM15 12V11.9974H14.9974L12.0007 9L9.78448 11.2153L9.52953 11.4704L9.00523 11.9961L9 12L9.00523 12.0052L12.0007 15L15 12Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusd);
export default __webpack_public_path__ + "static/media/busd.d4330632e2fd158794a73a5c0fe41ea5.svg";
export { ForwardRef as ReactComponent };